import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { createOrg } from "../redux/organizationsSagas";
import { FILTER_OPTIONS } from "../constants";
import { filterByDefault, schemaResolver, unregisterFields } from "../utils";

export const useAdd = () => {
  const dispatch = useDispatch();

  const {
    roles,
    availableGoals,
    availableStaffGoals,
    defaultDashboardModules,
    defaultConversionRevenueTypes,
    availablePages,
    locationalOverviewReportMetrics,
    membershipCalculationAgreementTypes,
    dateFormats,
    timeFormats
  } = useSelector((state) => state.organizations.commonSettings);

  const form = useForm({
    resolver: schemaResolver,
    defaultValues: {
      inactive: false,
      active_years: [FILTER_OPTIONS.activeYears[0]],
      currency: FILTER_OPTIONS.currencyList[0],
      date_format: dateFormats[0],
      time_format: timeFormats[0],
      default_client_role_id: roles[0],
      beginning_of_week: FILTER_OPTIONS.beginningOfWeek[0],
      client_name: "Client",
      inactive_clients: false,
      use_2fa: false,

      available_goals: filterByDefault(availableGoals, "isDefault"),
      available_staff_goals: filterByDefault(availableStaffGoals, "isDefault"),

      default_dashboard_modules: filterByDefault(defaultDashboardModules, "isDefault"),
      use_secondary_revenue_categories: false,

      zero_retention: false,
      count_same_day_conversion: false,
      default_conversion_revenue_types: filterByDefault(defaultConversionRevenueTypes, "isDefault"),
      show_future_appointments_on_funnel_laser: false,
      show_future_appointments_by_default: false,

      calculate_historical_data: false,
      calculate_autopay_schedules: false,
      calculate_challengers: false,
      show_laser_network_averages: false,
      leaderboard_details: false,
      risk_members_days_from_last_visit: 10,
      risk_members_days_prev_last_visit: 20,

      available_pages: availablePages.filter((item) => item.isDefault),
      locational_overview_report_metrics: filterByDefault(
        locationalOverviewReportMetrics,
        "isDefault"
      ),
      daily_email_notifier_class: FILTER_OPTIONS.dailyEmailNotifier[0],
      send_daily_report_emails: false,
      include_cross_regional_visits: false,
      start_from_appointment_by_default: false,
      exclude_preconverted_clients_from_appointments: false,
      exclude_frozen_members_from_total_members_count: true,
      attrition_rate_logic: FILTER_OPTIONS.attritionRateLogic[0],
      daily_pulse_attrition_rate_logic: FILTER_OPTIONS.attritionRateLogic[1],
      membership_calculation_agreement_types: filterByDefault(
        membershipCalculationAgreementTypes,
        "isDefault"
      ),
      membership_metric: FILTER_OPTIONS.membershipMetrics[0],
      membership_start: FILTER_OPTIONS.membershipStart[0]
    }
  });

  const { watch, unregister, handleSubmit } = form;

  const watchedValues = watch(["show_future_appointments_on_funnel_laser", "membership_metric"]);

  const [showFutureAppointments, membershipMetric] = watchedValues;

  const onSubmit = async (data) => {
    dispatch(createOrg(data));
  };

  useEffect(() => {
    unregisterFields({ unregister, showFutureAppointments, membershipMetric });
  }, [showFutureAppointments, membershipMetric]);

  return {
    ...form,
    watchedValues,
    submit: handleSubmit(onSubmit)
  };
};
